import React from "react";
import { Styled } from "./styles";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import ProfileForm from "@/components/profile";

const Profile: React.FC = () => {
    return (
        <Styled.Page>
            <ProfileForm />
        </Styled.Page>
    );
};

export default withErrorBoundary({ component: "Profile page" })(Profile);
